/**
 * AdminShell — Layout wrapper for all admin pages.
 * Renders the global bridge health panel as a fixed left column
 * and the page content as a scrollable right column.
 */
import type { ReactNode } from "react";
import { AdminBridgePanel } from "./components/AdminBridgePanel";

interface AdminShellProps {
    children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
    return (
        <div className="flex h-screen overflow-hidden bg-primary">
            <AdminBridgePanel />
            {/*
             * `relative` is required: it makes this scroll panel the containing block for any
             * absolutely-positioned descendants (e.g. React-Aria's visually-hidden <input> inside a
             * Switch/Checkbox). Without it those inputs fall back to the document as their containing
             * block and extend the document's scroll height; focusing one then scroll-into-views the
             * whole window, pushing the entire app (sidebar included) off-screen. Keeping them
             * contained here means focus scrolling stays inside this panel.
             */}
            <div className="relative flex flex-1 flex-col overflow-auto">{children}</div>
        </div>
    );
}
